import { render, staticRenderFns } from "./FirmaElettronicaComponent.vue?vue&type=template&id=39eec69c"
import script from "./FirmaElettronicaComponent.vue?vue&type=script&lang=js"
export * from "./FirmaElettronicaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports